// Moglee Base — cart drawer.
// Adds to cart without a page reload, refreshes the drawer through Shopify's
// section rendering, and falls back to normal form posts if anything fails.

(function () {
  var root = document.documentElement;
  var drawer = document.querySelector('[data-mb-cart-drawer]');
  if (!drawer) return;

  var sectionId = drawer.getAttribute('data-section-id');
  var lastFocus = null;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-mb-cart-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-mb-cart-close]');
    if (close) close.focus();
  }

  function close() {
    root.removeAttribute('data-mb-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshCount() {
    fetch(routeRoot() + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-mb-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.classList.toggle('mb-header__count--zero', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  function replaceDrawer(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-mb-cart-drawer]');
    if (!next) return;
    drawer.innerHTML = next.innerHTML;
    refreshCount();
  }

  // Add to cart from any product form.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    var data = new FormData(form);
    data.append('sections', sectionId);

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw body;
          return body;
        });
      })
      .then(function (body) {
        if (body.sections) replaceDrawer(body.sections[sectionId]);
        open();
      })
      .catch(function (error) {
        if (error && error.description) {
          window.alert(error.description);
        } else {
          form.submit();
        }
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.textContent = label;
        }
      });
  });

  // Quantity changes and removals inside the drawer or on the cart page.
  function change(key, quantity) {
    var container = document.querySelector('[data-mb-cart-open] [data-mb-cart-drawer]') || drawer;
    container.setAttribute('aria-busy', 'true');

    fetch(routeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (body) {
        if (body.sections) replaceDrawer(body.sections[sectionId]);
        refreshCount();
        if (document.querySelector('[data-mb-cart-page]')) window.location.reload();
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        container.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mb-cart-toggle]');
    if (opener) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-mb-cart-close]') || event.target.closest('[data-mb-cart-overlay]')) {
      event.preventDefault();
      close();
      return;
    }

    var step = event.target.closest('[data-mb-qty]');
    if (step) {
      event.preventDefault();
      change(step.getAttribute('data-key'), parseInt(step.getAttribute('data-qty'), 10));
      return;
    }

    var remove = event.target.closest('[data-mb-remove]');
    if (remove) {
      event.preventDefault();
      change(remove.getAttribute('data-key'), 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.getAttribute('data-mb-cart-open') === 'true') close();
  });
})();
